'use client';

import { use } from 'react';

import { Context } from './gas-tariffs-context';

export const useGasTariffs = () => {
  const tariffsPromise = use(Context);

  if (!tariffsPromise) {
    return null;
  }

  return use(tariffsPromise).data;
};

export const useGasProduct = (productCode: string | undefined) => {
  const data = useGasTariffs();

  if (!productCode) {
    return;
  }

  return data?.tariffs.flat().find((product) => product.productCode === productCode);
};
